import React from "react";

const Bash_Du = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Du</h2>
      <p>Estimate file or directory space usage.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>du [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>du -sh *
du -h /var/log</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Useful to find which directories consume space.</p>
    </div>
  );
};

export default Bash_Du;
